import { AnyAction } from 'redux';
import { ILoadingError } from '#/types/global';
import { IArtistResponse } from '#/types/API/artists';
import {
  createActionArtistRelatedError,
  createActionArtistRelatedReset,
  createActionArtistRelatedSetRelatedArtists,
  createActionArtistRelatedStartLoading,
  createActionArtistRelatedStopLoading,
} from '../actions/artistRelated';

export interface IArtist {
  relatedArtists?: IArtistResponse[];
}

type TState = IArtist & ILoadingError;

const initialState: TState = { _loading: true, _error: false };

const artistRelated = (
  state: TState = initialState,
  action: AnyAction
): TState => {
  if (createActionArtistRelatedSetRelatedArtists.doesMatch(action)) {
    return { ...state, relatedArtists: action.payload };
  }

  if (createActionArtistRelatedStartLoading.doesMatch(action)) {
    return { ...state, _loading: true };
  }

  if (createActionArtistRelatedStopLoading.doesMatch(action)) {
    return { ...state, _loading: false };
  }

  if (createActionArtistRelatedError.doesMatch(action)) {
    return { ...state, _error: true };
  }

  if (createActionArtistRelatedReset.doesMatch(action)) {
    return initialState;
  }

  return state;
};

export default artistRelated;
